import officeApiExecAsync from './infrastructure/office-api-exec-async'
import officeApiGetAsync from './infrastructure/office-api-get-async'

export async function officeApiItem_BodyGetTypeAsync(): Promise<Office.CoercionType> {
  return officeApiGetAsync<Office.CoercionType>(
    '1.1',
    'body.getTypeAsync',
    () => new Promise<Office.AsyncResult<Office.CoercionType>>((resolve) => Office.context.mailbox.item.body.getTypeAsync(resolve)),
    Office.CoercionType.Html,
  )
}

export async function officeApiItem_BodyGetAsync(type: Office.CoercionType, defaultValue?: string): Promise<string> {
  if (type === null) {
    type = await officeApiItem_BodyGetTypeAsync()
  }

  return await officeApiGetAsync<string>(
    '1.3',
    'body.getAsync',
    () => new Promise<Office.AsyncResult<string>>((resolve) => Office.context.mailbox.item.body.getAsync(type, resolve)),
    defaultValue,
  )
}

export async function officeApiItem_BodySetAsync(body: string): Promise<boolean> {
  const options: Office.CoercionTypeOptions = {
    coercionType: await officeApiItem_BodyGetTypeAsync(),
  }

  return officeApiExecAsync(
    '1.3',
    'body.setAsync',
    () => new Promise<Office.AsyncResult<void>>((resolve) => Office.context.mailbox.item.body.setAsync(body, options, resolve)),
  )
}

export async function officeApiItem_BodySetSelectedDataAsync(body: string): Promise<boolean> {
  const options: Office.CoercionTypeOptions = {
    coercionType: await officeApiItem_BodyGetTypeAsync(),
  }

  return officeApiExecAsync(
    '1.1',
    'body.setSelectedDataAsync',
    () => new Promise<Office.AsyncResult<void>>((resolve) => Office.context.mailbox.item.body.setSelectedDataAsync(body, options, resolve)),
  )
}

export async function officeApiItem_BodyPrependAsync(body: string): Promise<boolean> {
  const options: Office.CoercionTypeOptions = {
    coercionType: await officeApiItem_BodyGetTypeAsync(),
  }

  return officeApiExecAsync(
    '1.1',
    'body.prependAsync',
    () => new Promise<Office.AsyncResult<void>>((resolve) => Office.context.mailbox.item.body.prependAsync(body, options, resolve)),
  )
}

export async function officeApiItem_BodyAppendOnSendAsync(body: string): Promise<boolean> {
  const options: Office.CoercionTypeOptions = {
    coercionType: await officeApiItem_BodyGetTypeAsync(),
  }

  return officeApiExecAsync(
    '1.9',
    'body.appendOnSendAsync',
    () => new Promise<Office.AsyncResult<void>>((resolve) => Office.context.mailbox.item.body.appendOnSendAsync(body, options, resolve)),
  )
}
